import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AdminBookingsService } from '../service/admin-bookings.service';

@Component({
  selector: 'app-show-notification',
  templateUrl: './show-notification.component.html',
  styleUrls: ['./show-notification.component.css']
})
export class ShowNotificationComponent implements OnInit {
  confirmationId: string;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<any>,
    private adminBookingSvc: AdminBookingsService) { }

  ngOnInit() {
    this.confirmationId = this.data;
  }

  refreshPage() {
    this.dialogRef.close(true);
    this.adminBookingSvc.setRefreshPage(true);
  }
}
